<template>
  <div class="waper">
    <div class="left-ztbl">各地区农机数量及面积分布（累计数据）</div>
    <div id="Citychars">
    </div>
    <div class="Gap">农机数量</div>
    <div class="Gap-right">预计作业面积</div>
  </div>
</template>
<script>
import "echarts/map/js/china.js"
import  Api from '../../../Serves/net-api.js'
import Http from '../../../Serves/net-http.js'
import {mapState,mapActions,mapMutations} from "vuex";
export default {
  name:'AreaItem',
  data(){
    return{
      Citychars:'',
      total:[], // 各地区农机总数
      totalArea:[], // 预计作业面积
      name:[], // 地区名称
      cityName:''
    }
  },
  beforeDestroy(){
    // 释放echars
    /*chart.clear()*/
    // this.Citychars.dispose()
    this.Citychars=null
    this.bus.$off('statue')
  },
  mounted (){
    this.cityName=this.$store.state.areaName
    // this.$nextTick(() => {
      // this.getData()
      this.fistdata()
      this.getdata() // 首次加载无数据图
      // 监听省份变化
      this.bus.$on('statue',res=>{
        console.log(res)
        if(res.city!=this.propsState){
            if(res.city=='切换'){
              this.total=[]
              this.totalArea=[]
              this.name=[]
              // this.fistdata(res.city)
              return
            }
            var url=Http.test+'/applicationSubsidy/statisticsNjNumAndWorkAreaByArea\n'
            // 农机折线图数据
            this.total=[]
            this.totalArea=[]
            this.name=[]
            Api.doPost(url,null,false,(res)=>{
              this.name=[]
              for(var i=0;i<res.result.length;i++){
                this.total.push(res.result[i].total)
                this.totalArea.push(res.result[i].totalArea)
                this.name.push(res.result[i].name)
              }
              var mapData = res.result.map(item => {
                return {
                  name: item.name,
                  value: item.total
                }
              })
              this.$store.commit('mapDatas',mapData)
              this.getdata()
            },(err)=>{
            })
        }else {
          console.log('相同')
        }
      })
    // })
    // 图表自适应
    var than = this
    this.init()
  },
  created () {
    
  },
  destroyed: function() {
    this.bus.$off('statue')
    window.removeEventListener("resize",this.init,30)
  },
  methods:{
    // ...mapActions(['getAccountInfo']),
    init(){
      setTimeout(()=>{
        window.addEventListener("resize",()=>{
          this.Citychars.resize()
        })
      },30)
    },
    getData(){
      var parmes = {
        provCode: this.$store.state.info.provCode
      }
      var url=Http.test+'/applicationSubsidy/statisticsNjNumAndWorkAreaByArea'
      Api.doPost(url,null,false,(res)=>{
        var mapData = res.result.map(item => {
          return {
            name: item.name,
            value: item.total
          }
        })
        this.$store.commit('mapData',mapData)
      },(err)=>{

      })
    },
    // 首次请求全国数据
    fistdata(city){
      var areaNames = this.$store.state.areaName
      // 先判断首次请求那个层级数据
      var parmes=null
      if (city === undefined) {
        var url=Http.test+'/applicationSubsidy/statisticsNjNumAndWorkAreaByArea'
        Api.doPost(url,null,false,(res)=>{
          this.name = []
          for(var i=0;i<res.result.length;i++){
            this.total.push(res.result[i].total)
            this.totalArea.push(res.result[i].totalArea)
            this.name.push(res.result[i].name)
          }
          var mapData = res.result.map(item => {
            return {
              name: item.name,
              value: item.total
            }
          })
          this.$store.commit('mapData',mapData)
          this.getdata()
        },(err)=>{

        })
      }
    },
    getdata(){
      this.Citychars=this.$echarts.init(document.getElementById('Citychars'))
      this.Citychars.setOption({
        // backgroundColor: '#0B1640',
          grid: {
            top: '25%', // 距离容器上边界40像素
            bottom: '15%', // 距离容器下边界30像素
            left:100,
            right:115,
          },
          title: {
          // text: '各地区农机数量及面积分布（累计数据）',
          subtext: '',
          textStyle:{
            // 文字颜色
            color:'#ffffff',
            // 字体风格,'normal','italic','oblique'
            fontStyle:'normal',
            // 字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight:'normal',
            // 字体系列
            fontFamily:'sans-serif',
            // 字体大小
            fontSize:18
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#0B1640'
            }
          }
        },
        // 标题
        legend: {
          data:[ '农机数量（台/套）','作业面积（亩）'],
          textStyle: {
            color: '#ffffff',
            fontSize:14
          }
        },
        /*dataZoom: {
          show: false,
          start: 0,
          end: 100
        },*/
        xAxis: [
          {
            type: 'category',
            axisLine: {
              lineStyle: { //x轴颜色和字体大小
                color: '#fff',
                fontSize: '14'
              }
            },
            axisLabel: {
              // fontSize:  window.screen.width < 1500 ? 14 : 16,
              interval:0
            },
            boundaryGap: true,
            data:this.name // 省名称
          },
          { // 作业面积鼠标放上显示
            type: 'category',
            axisLine: {
              lineStyle: { //x轴颜色和字体大小
                color: '#fff',
                fontSize: '14'
              }
            },
            boundaryGap: true,
            data:this.name
          }
        ],
        yAxis: [
          // y轴颜色设置
          {
            type: 'value',
            axisLine: {
              show: false, // y轴坐标线
              lineStyle: {
                color: '#DBE0FE',
                fontSize: '18'
              }
            },
            splitLine:{ // 坐标格样式设置
              show:false,
              lineStyle:{
                type:'dashed',
                color:'#092786'
              }
            },
            // 去掉刻度线
            axisTick: {
              show: false
            },
            scale: true,
            // name: '农\n机\n数\n量',
            nameTextStyle : {
              color: "#75C3FF"
            },
            /* max: 800, */
            min: 0,
            boundaryGap: [0.2, 0.2],
            axisLabel: {
              show: true,
              textStyle: {
                fontSize : 14 // 更改坐标轴文字大小
              }
            }
          },
          { // y右边设置
            type: 'value',
            axisLine: {
              show: false, // y轴右边坐标线
              lineStyle: {
                color: '#DBE0FE',
                fontSize: '14'
              }
            },
            splitLine:{ // 坐标格样式设置
              show:false,
              lineStyle:{
                type:'dashed',
                color:'#092786'
              }
            },
            // 去掉刻度线
            axisTick: {
              show: false
            },
            scale: true,
            // name: '预计作业面积',
            nameTextStyle : {
              color: "#75C3FF"
            },
            /*max: 20000,*/
            min: 0,
            boundaryGap: [0.2, 0.2],
            axisLabel: {
              show: true,
              textStyle: {
                fontSize : 14 // 更改坐标轴文字大小
              }
            }
          }
        ],
        series: [
          {
            name:'作业面积（亩）',
            type:'bar',
            // 设置柱子的宽度
            barWidth: 30,
            color:"#01C2FF",
            xAxisIndex: 1,
            yAxisIndex:1,
            position:'left',
            data:this.totalArea // 鼠标划上的农机数
          },
          {
            name:'农机数量（台/套）',
            type:'line',
            color:'#FF5D0E',
            data:this.total // 鼠标划上的作业面积
          }
        ]
      })
    }
  }
}
</script>
<style scoped>
  #Citychars{
    width:99%;
    height: 25vh;
    margin-top: 2vh;
  }
  .Gap{
    position: absolute;
    left: 25px;
    top: 91px;
    z-index: 100;
    width: 20px;
    color: #75C3FF;
    font-size: 16px;
  }
  .Gap-right{
    position: absolute;
    top: 91px;
    z-index: 100;
    width: 20px;
    color: #75C3FF;
    right:25px;
    font-size: 16px;
  }
  .waper{
    height: 28.5vh;
    /*margin-top: 15px;*/
    background: url("/static/img/bottom.png")no-repeat;
    background-size:100% 100%;
    position: relative;
    top:0px;
    padding: 1vh 10px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/Subsidies/common/AreaItem.vue